{
  "plans": {
    "title": "Our plans",
    "subtitle": "Compare what each plan unlocks. You can change at any time.",
    "current": "Your current plan",
    "free": "Free",
    "included": "Included",
    "excluded": "Not included",
    "unlimited": "Unlimited",
    "interval": {
      "month": "/ month",
      "year": "/ year",
      "one_time": "one-off"
    },
    "unit": {
      "mb": "MB",
      "count": ""
    }
  },
  "subscription": {
    "title": "My subscription",
    "noSubscription": "You are on the free plan.",
    "status": {
      "trialing": "Trial in progress",
      "active": "Subscription active",
      "past_due": "Payment pending — your access stays open",
      "canceled": "Subscription canceled",
      "incomplete": "Sign-up incomplete",
      "expired": "Subscription expired"
    },
    "trialEnds": "Your trial ends on {{date}}.",
    "renewsOn": "Renews on {{date}}.",
    "endsOn": "Your access ends on {{date}}.",
    "seePlans": "See plans",
    "cancel": "Cancel subscription",
    "usage": "Usage",
    "usedOf": "{{usedValue}} of {{limitValue}}",
    "usedUnlimited": "{{usedValue}} used"
  },
  "paywall": {
    "title": "This feature is not in your plan",
    "body": "“{{featureLabel}}” requires a higher plan.",
    "genericBody": "This action requires a higher plan.",
    "thisFeature": "this feature",
    "limitReached": "You have {{currentValue}} of {{limitValue}} allowed.",
    "quotaExceeded": "You have used {{usedValue}} of {{limitValue}} allowed.",
    "seePlans": "See plans"
  },
  "features": {
    "storage.upload": "File upload",
    "storage.quota_mb": "Storage space",
    "storage.max_file_mb": "Maximum file size",
    "courses.max": "Publishable courses",
    "students.max": "Enrolled students",
    "messaging.enabled": "Messaging",
    "certificates.enabled": "Certificates",
    "analytics.advanced": "Advanced analytics",
    "branding.custom": "Custom branding"
  },
  "admin": {
    "title": "Plan and entitlements",
    "currentPlan": "Current plan: {{plan}}",
    "choosePlan": "Plan to activate",
    "activate": "Activate plan",
    "changePlan": "Change plan",
    "cancel": "Cancel immediately"
  }
}
